import * as yup from 'yup';
import { AddressFormData } from '../../types/Address';
import { phoneNumberValidator } from './Customer';
import {
  getOptionalStringValidator,
  getRequiredStringValidator,
} from './Generators';

export const firstNameValidator = getRequiredStringValidator().trim();
export const lastNameValidator = getRequiredStringValidator().trim();
export const address1Validator = getRequiredStringValidator().trim();
export const address2Validator = getOptionalStringValidator();
export const cityValidator = getRequiredStringValidator().trim();
export const stateValidator = getRequiredStringValidator().trim();
export const postalCodeValidator = getRequiredStringValidator().min(2).trim();
export const unitedStatesPostalCodeValidator =
  getRequiredStringValidator().matches(
    /^\d{5}(-\d{4})?$/,
    'Please enter a valid zip code'
  );
export const countryValidator = getRequiredStringValidator().trim();
export const companyNameValidator = getOptionalStringValidator();

export const addressSchema = yup.object<AddressFormData>().shape({
  firstName: firstNameValidator,
  lastName: lastNameValidator,
  address1: address1Validator,
  address2: address2Validator,
  city: cityValidator,
  state: stateValidator,
  postalCode: yup.string().when('country', {
    is: 'United States',
    then: unitedStatesPostalCodeValidator,
    otherwise: postalCodeValidator,
  }),
  country: countryValidator,
  companyName: companyNameValidator,
  phoneNumber: phoneNumberValidator,
});

export const requiredAddressFields = [
  'firstName',
  'lastName',
  'address1',
  'city',
  'state',
  'postalCode',
  'phoneNumber',
];
